module.exports = __webpack_public_path__ + "img/chinesecompany111.41d2a836.png";